<template>
  <div class="checkbox">
    <label class="checkbox__wrapper">
      <input
        @change="handleChange"
        type="checkbox"
        :disabled="disabled"
        :checked="checked"
      />
      <span class="checkbox__checkmark">
        <span class="checkbox__on">on</span>
        <span class="checkbox__off">off</span>
      </span>
    </label>
    <span v-if="!!label" class="checkbox__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "on"
    },
    label: {
      type: String,
      default: ""
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      on: this.checked
    }
  },
  methods: {
    handleChange() {
      this.on = !this.checked
      this.$emit("toggled-checkbox-change", this.on)
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";

.checkbox {
  $self: &;
  display: inline-flex;
  flex-flow: row nowrap;

  &__wrapper {
    align-self: flex-start;
    position: relative;
    user-select: none;
  }
  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  &__checkmark {
    display: inline-block;
    position: relative;
    width: 88px;
    height: 40px;
    background: $color-neutral-4;
    background: var(--color-neutral-4, $color-neutral-4);
    border-radius: 40px;

    &,
    &:after {
      transition: all 0.3s ease;
    }

    &:after {
      content: "";
      height: 32px;
      width: 32px;
      background: white;
      position: absolute;
      border-radius: 50%;
      top: 10%;
      left: 6%;
    }
  }

  &__on,
  &__off {
    text-transform: uppercase;
    color: white;
    position: absolute;
    top: 33%;
    font-size: 0.8em;
    font-weight: 600;
    transition: opacity 0.3s ease-in;
  }

  &__on {
    left: 16px;
    opacity: 0;
  }
  &__off {
    right: 16px;
  }

  & input:not(:disabled) {
    & ~ #{$self}__checkmark {
      cursor: pointer;
    }
  }

  & input:disabled:not(:checked) {
    & ~ #{$self}__checkmark {
      background: $color-neutral-2;
      background: var(--color-neutral-2, $color-neutral-2);
    }
  }

  & input:checked {
    & ~ #{$self}__checkmark {
      background: $color-secondary;
      background: var(--color-secondary, $color-secondary);

      #{$self}__on {
        opacity: 1;
      }
      #{$self}__off {
        opacity: 0;
      }

      &:after {
        left: 60%;
      }
    }
  }

  & input:checked:disabled ~ #{$self}__checkmark {
    background: $color-secondary--light;
    background: var(--color-secondary--light, $color-secondary--light);
  }

  &__label {
    min-width: 150px;
    max-width: 276px;
    margin-left: 10px;
  }
}
</style>
